import { clientInstance } from "../config/config";

/**
 * Get Agora configuration (App ID and Channel Name) for a session
 */
export const getAgoraConfigAPI = async (sessionId) => {
    return clientInstance.get(`/session/${sessionId}/agora-config`);
};

/**
 * Generate Agora RTC token for joining a session
 * @param {String} sessionId - Session ID
 * @param {Number} uid - User ID (optional, 0 for auto-assigned)
 */
export const generateAgoraTokenAPI = async (sessionId, uid = 0) => {
    return clientInstance.post(`/session/${sessionId}/agora-token`, { uid });
};

/**
 * Get session participants information (tutor and student names)
 */
export const getSessionParticipantsAPI = async (sessionId) => {
    return clientInstance.get(`/session/${sessionId}/participants`);
};

/**
 * Generate whiteboard room token for joining a whiteboard session
 * @param {String} sessionId - Session ID
 */
export const generateWhiteboardTokenAPI = async (sessionId) => {
    return clientInstance.post(`/session/${sessionId}/whiteboard-token`);
};

